import useLogger from "./useLogger";
import usePortalType from "./usePortalType";

const useTruckDownloadForm = () => {
  const logger = useLogger();
  const portalType = usePortalType();

  return (user) => {
    logger.trackEvent("Form Download", {
      portal: portalType ?? "",
      formName: user?.formTitle,
      formTitle: user?.formTitle,
      productType: user?.productType,
      company: user?.company,
      issueState: user?.issueState,
      formID: user?.formID,
      searchType: user?.searchType,
      userName: user?.userName ?? "",
    });
  };
};

export default useTruckDownloadForm;
